import { setCurrentSceneId } from '../actions';
import { ScenesAction } from '../types';

const currentSceneId = (state = 0, action: ScenesAction) => {
  switch (action.type) {
    case setCurrentSceneId.type:
      return action.payload;

    default:
      return state;
  }
};

export default currentSceneId;
